import * as React from "react";
const SvgCustomLocation = ({
  title,
  titleId,
  ...props
}) => <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" aria-labelledby={titleId} {...props}>{title === undefined ? <title id={titleId}>{"Custom location"}</title> : title ? <title id={titleId}>{title}</title> : null}<rect x={0.72} y={3.6} width={22.56} height={16.8} rx={2.16} stroke="currentColor" strokeWidth={1.44} /><path stroke="currentColor" strokeWidth={1.5} d="M4.75 6.88v11" /></svg>;
export default SvgCustomLocation;